import { HttpClient } from '../httpClient';
import InvoiceDetailReportResponse from '../responses/invoiceDetailReportResponse';
import InvoiceExportDetailResponse from '../responses/invoiceExportDetailResponse';
import InvoiceExportRequest from '../requests/invoiceExportRequest';
import InvoiceReviewDistrictResponse from '../responses/invoiceReviewDistrictResponse';
import InvoiceReviewDistrictsRequest from '../requests/invoiceReviewDistrictsRequest';
import InvoiceReviewDistrictsResponse from '../responses/invoiceReviewDistrictsResponse';
import InvoiceReviewRequest from '../requests/invoiceReviewRequest';
import InvoiceSummaryReportResponse from '../responses/invoiceSummaryReportResponse';
import StringResponse from '../responses/stringResponse';

const httpClient = new HttpClient();

export const getInvoiceDistricts = async (
  request: InvoiceReviewDistrictsRequest
) => {
  return httpClient.post<InvoiceReviewDistrictsResponse>({
    url: `/v1/Invoice/Summary`,
    payload: request,
    requiresToken: true,
  });
};

export const createInvoiceReview = async (
  request: InvoiceReviewRequest
) => {
  return httpClient.post<InvoiceReviewDistrictResponse>({
    url: `/v1/Invoice/Reviews/Create`,
    payload: request,
    requiresToken: true,
  });
};

export const getInvoiceDetailReport = async (districtId: number, year: number, month: number, programId: number | undefined = undefined) => {
  return httpClient.get<InvoiceDetailReportResponse>({
    url: `/v1/Invoice/Reports/Detail/?districtId=${districtId}&year=${year}&month=${month}${programId ? `&programId=${programId}` : ''}`,
    requiresToken: true,
  });
};

export const getInvoiceSummaryReport = async (districtId: number, year: number, month: number, programId: number | undefined = undefined) => {
  return httpClient.get<InvoiceSummaryReportResponse>({
    url: `/v1/Invoice/Reports/Summary/?districtId=${districtId}&year=${year}&month=${month}${programId ? `&programId=${programId}` : ''}`,
    requiresToken: true,
  });
};

export const getExportedInvoices = async () => {
  return httpClient.get<InvoiceExportDetailResponse>({
    url: `/v1/Invoice/ExportedInvoices`,
    requiresToken: true,
  });
};

export const exportInvoices = async (request: InvoiceExportRequest) => {
  return httpClient.post<InvoiceExportDetailResponse>({
    url: `/v1/Invoice/Export`,
    payload: request,
    requiresToken: true,
  });
};

export const undoInvoices = async (request: InvoiceExportRequest) => {
  return httpClient.post<InvoiceExportDetailResponse>({
    url: `/v1/Invoice/UndoInvoices`,
    payload: request,
    requiresToken: true,
  });
};

export const downloadInvoices = async (request: InvoiceExportRequest) => {
  return httpClient.post<StringResponse>({
    url: `/v1/Invoice/Download`,
    payload: request,
    requiresToken: true,
  });
};

export const sendInvoices = async (request: InvoiceExportRequest) => {
  return httpClient.post({
    url: '/v1/Invoice/sendInvoices',
    payload: request,
    requiresToken: true,
  });
};

export const exportedInvoiceByRequest = async (request: InvoiceExportRequest) => {
  return httpClient.post<InvoiceExportDetailResponse>({
    url: '/v1/Invoice/ExportedInvoiceByRequest',
    payload: request,
    requiresToken: true,
  });
};